import { shallowEqual, useSelector } from 'react-redux';

export const useShallowSelector = (selector, ...args) => {
  const computedSelector = args?.length > 0 ? selector(...args) : selector;

  return useSelector(computedSelector, shallowEqual);
};
